import NotFoundPage from '@/pages/not-found.page';
import Journeys from '@/pages/journeys';
import { AppBundle } from '@/utils/app-bundles';
import { useActiveBundle } from '@/context/active-bundle';
import { createFileRoute } from '@tanstack/react-router';

function WorkspaceSplatRoute() {
  // Reactive (account-aware) bundle from the provider — render-time snapshots
  // of getAppBundleFromUrl would cache the pre-auth flag defaults.
  const appBundle = useActiveBundle();

  switch (appBundle) {
    case AppBundle.Journeys:
      return <Journeys />;
    case null:
      return <NotFoundPage />;
    default: {
      const _exhaustive: never = appBundle;
      return String(_exhaustive);
    }
  }
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/$')({
  component: WorkspaceSplatRoute,
});
